/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Changelogcharts_Byfielddesc3Inputs */

const id_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan dikelompokkan berdasarkan bidang yang diubah`)
};

const ms_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan dikumpulkan mengikut medan yang diubah`)
};

const da_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændringer grupperet efter ændret felt`)
};

const de_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen gruppiert nach geändertem Feld`)
};

const en_us2_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes grouped by it's changed field`)
};

const es_es2_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios agrupados por el campo modificado`)
};

const es_mx2_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios agrupados por el campo modificado`)
};

const fil_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga pagbabagong naka-grupo ayon sa binagong field`)
};

const fr_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications groupées par champ modifié`)
};

const it_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche raggruppate per campo modificato`)
};

const hu_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Változások a megváltoztatott mező szerint csoportosítva`)
};

const nl_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wijzigingen gegroepeerd per gewijzigd veld`)
};

const no_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endringer gruppert etter endret felt`)
};

const pl_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmiany pogrupowane według zmienionego pola`)
};

const pt_br2_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes grouped by it's changed field`)
};

const pt_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações agrupadas pelo campo alterado`)
};

const ro_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări grupate după câmpul modificat`)
};

const fi_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muutokset ryhmiteltynä muuttuneen kentän mukaan`)
};

const sv_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändringar grupperade efter ändrat fält`)
};

const vi_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi được nhóm theo trường đã thay đổi`)
};

const tr_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değiştirilen alana göre gruplandırılmış değişiklikler`)
};

const cs_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změny seskupené podle změněného pole`)
};

const bg_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промени, групирани по промененото поле`)
};

const ru_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения, сгруппированные по изменённому полю`)
};

const uk_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зміни, згруповані за полем зміни`)
};

const ar_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات مجمعة حسب الحقل المتغير`)
};

const hi_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ील्ड द्वारा समूहित परिवर्तन`)
};

const th_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงจัดกลุ่มตามฟิลด์ที่เปลี่ยน`)
};

const ja_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更されたフィールドでグループ化された変更`)
};

const zh_cn2_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes grouped by it's changed field`)
};

const zh_hant1_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes grouped by it's changed field`)
};

const ko_components_changelogcharts_byfielddesc3 = /** @type {(inputs: Components_Changelogcharts_Byfielddesc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes grouped by it's changed field`)
};

/**
* | output |
* | --- |
* | "Changes grouped by it's changed field" |
*
* @param {Components_Changelogcharts_Byfielddesc3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_changelogcharts_byfielddesc3 = /** @type {((inputs?: Components_Changelogcharts_Byfielddesc3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Changelogcharts_Byfielddesc3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "ms") return ms_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "da") return da_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "de") return de_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "en-US") return en_us2_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "es-ES") return es_es2_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "es-MX") return es_mx2_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "fil") return fil_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "fr") return fr_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "it") return it_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "hu") return hu_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "nl") return nl_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "no") return no_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "pl") return pl_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "pt-BR") return pt_br2_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "pt") return pt_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "ro") return ro_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "fi") return fi_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "sv") return sv_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "vi") return vi_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "tr") return tr_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "cs") return cs_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "bg") return bg_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "ru") return ru_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "uk") return uk_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "ar") return ar_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "hi") return hi_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "th") return th_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "ja") return ja_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_changelogcharts_byfielddesc3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_changelogcharts_byfielddesc3(inputs)
	return ko_components_changelogcharts_byfielddesc3(inputs)
});
export { components_changelogcharts_byfielddesc3 as "components.changelogCharts.byFieldDesc" }